export default __webpack_public_path__ + "static/media/Mercado_Libre-24.3e252bc5.svg";